import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import Button from 'antd/lib/button'
import Input from 'antd/lib/input'
import Divider from 'antd/lib/divider'
import { Auth } from 'aws-amplify'

import {
    setShowNewPassword,
    setErrorMessage,
    setUser,
    setCreateNewOccupancy,
} from '../../redux/auth/actions'
import ResetPassword from './ResetPassword'

const styles = {
    backgroundContainer: {
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        bottom: 0,
        height: '100%',
        left: 0,
        position: 'absolute',
        right: 0,
        top: 0,
    },
    card: {
        background: 'rgba(255, 255, 255, 0.74)',
        borderRadius: '12px',
        padding: '0 0.32em',
    },
    formContainer: {
        position: 'absolute',
        left: '50%',
        margin: 'auto',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: 520,
    },
    logoContainer: {
        margin: '10px auto',
        textAlign: 'center',
        width: 200,
    },
    signUpLink: {
        display: 'block',
        marginTop: '3em',
        textAlign: 'center',
    },
    submitButton: {
        width: 140,
        borderRadius: 7
    },
    ssoButton: {
        width: '100%',
        marginBottom: 5,
        background: '#52c41a',
        borderColor: '#52c41a'
    },
    submitContainer: {
        textAlign: 'center',
    },
    welcome: {
        marginTop: '1em',
        textAlign: 'center',
    },
    signUpButton: {
        marginLeft: 5,
    },
    link: {
        color: '#1BAAF1',
        cursor: 'pointer',
    },
    linkRight: {
        color: '#1BAAF1',
        cursor: 'pointer',
        float: 'right',
    },
    error: {
        color: 'red',
        textAlign: 'center',
        fontSize: 14,
    },
    actions: {
        marginTop: '1.64em',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontWeight: 600
    }
}

const Login = ({ showLathamSSO }) => {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [showResetPassword, setShowResetPassword] = useState(false)
    const showConfirmationForm = useSelector((state) => state.auth.showConfirmationForm)
    const errorMessage = useSelector((state) => state.auth.errorMessage)
    const loginData = useSelector(state => state.auth.data)

    const login = (e) => {
        if (password.length > 0) {
            Auth.signIn(email.toLowerCase(), password.trim())
                .then((user) => {
                    if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
                        setUser(user)
                        setErrorMessage('')
                        setShowNewPassword(true)
                    } else {
                        if(loginData) {
                            setCreateNewOccupancy(true)
                        }
                        // onStateChange('signedIn', {})
                    }
                })
                .catch((err) => {
                    if (err.message === 'Username cannot be empty') {
                        setErrorMessage('Email cannot be empty')
                    } else if(err.code === 'NotAuthorizedException') {
                        setErrorMessage('Incorrect email or password.')
                    } else {
                        setErrorMessage(err.message)
                    }
                  
                    if (err.code === 'PasswordResetRequiredException') {
                        setShowResetPassword(true)
                    }
                    if (err.code === 'UserNotConfirmedException') {
                        showConfirmationForm(email.toLowerCase(), null, true)
                    }
                })
        } else {
            setErrorMessage('Password cannot be empty')
        }
    }

    const checkKeyPress = (e) => {
        const { key, keyCode } = e;
        if (keyCode === 13) {
            login()
        }
    }

    const onNavigation = () => {
        setErrorMessage('')
        setShowResetPassword(!showResetPassword)
    }

    return (
        <>
            {!showResetPassword && (
                <div style={{ marginTop: '0.64em' }}>
                    <div style={styles.error}>{errorMessage}</div>
                    <div>
                        <span style={{ marginLeft: 10 }}>Email:</span>
                        <Input
                            onChange={(e) => setEmail(e.target.value)}
                            type="email"
                            value={email}
                        />
                        <div style={{ marginTop: '1em' }}>
                            <span style={{ marginLeft: 10 }}>Password:</span>
                            <Input
                                onChange={(e) => setPassword(e.target.value)}
                                type="password"
                                value={password}
                                onKeyDown={checkKeyPress}
                            />
                        </div>
                        <div style={styles.actions}>
                            <span onClick={onNavigation} style={styles.link}>
                                Forgot Password?
                            </span>
                            <Button
                                htmlType="submit"
                                onClick={login}
                                size="large"
                                style={styles.submitButton}
                                type="primary"
                            >
                                Login
                            </Button>
                        </div>

                        {showLathamSSO && (
                            <div>
                                <Divider>Or</Divider>
                                <Button
                                    htmlType="submit"
                                    href={process.env.REACT_APP_LATHAM_SSO_URL}
                                    target='_blank'
                                    size="large"
                                    style={styles.ssoButton}
                                    type="primary">
                                    Single-Sign On
                                </Button>
                            </div>
                        )}
                    </div>
                </div>
            )}
            {showResetPassword && <ResetPassword email={email} visible={showResetPassword} onClose={onNavigation} />}
        </>
    )
}

export default Login
